import {
  Col,
  Row,
  Button,
  Form,
  Alert,
  OverlayTrigger,
  Popover,
  Image,
} from "react-bootstrap";
import { useTranslation } from "react-i18next";
import TableComp from "../component/Table";
import { useState, useEffect, useCallback } from "react";
import { t } from "i18next";
import NavLink from "../component/NavLink";
import Filter from "../component/Filter";
import { BiSolidDollarCircle } from "react-icons/bi";
import { BsGraphUpArrow } from "react-icons/bs";
import { FiDivideCircle } from "react-icons/fi";
import TimeLine from "../component/Timeline";
import { useLocation, useNavigate } from "react-router-dom";
// import { IoMdArrowRoundBack, IoMdArrowRoundForward } from "react-icons/io";
import ApiUtil from "../util/ApiUtil";
import ApiPath from "../util/ApiPath";
import Pagination from "react-responsive-pagination";
import "react-responsive-pagination/themes/classic.css";
import ReactLoading from "react-loading";
import SessionUtil from "../util/SessionUtil";
import OrderModal from "../component/OrderModal";
import { ActionRow } from "../component/ActionRow";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css"; // مهم جداً

const CustomRow = ({ rowData, columnNames, handleClickRow, page }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <tr>
      {columnNames.map((columnName, index) => (
        <td
          key={index}
          onClick={() => handleClickRow(page === "store" && "item", rowData)}
        >
          {columnName === "orderNo" ? (
            <span>#{rowData.OrderId}</span>
          ) : columnName === "Notes" ? (
            <OverlayTrigger
              trigger="click"
              placement={"top"}
              rootClose
              overlay={
                <Popover id={`Notes`}>
                  <Popover.Header as="h5">{t("Notes")}</Popover.Header>
                  <Popover.Body>
                    <p className="mb-0 w-200">
                      {rowData?.Notes ? rowData.Notes : "--"}
                    </p>
                  </Popover.Body>
                </Popover>
              }
            >
              <p className="mb-0 cursor-pointer w-200" title={t("click here")}>
                {rowData?.Notes ? rowData.Notes : "--"}
              </p>
            </OverlayTrigger>
          ) : columnName === "Image" ? (
            rowData?.OrderImage ? (
              <div className="dimension-40">
                <Image
                  alt="image"
                  src={rowData.OrderImage}
                  className="img-fluid cursor-pointer"
                  onClick={() => setIsOpen(true)}
                />
                {isOpen && (
                  <Lightbox
                    mainSrc={rowData.OrderImage}
                    onCloseRequest={() => setIsOpen(false)}
                  />
                )}
              </div>
            ) : (
              <div className="img-empty"></div>
            )
          ) : columnName === "Total" ? (
            <div className="flex-gap-2">
              <BiSolidDollarCircle size={16} color={"#3A974C"} />{" "}
              <p className="mb-0">{rowData.TotalPrice}</p>
            </div>
          ) : columnName === "TotalWithProfit" ? (
            <div className="flex-gap-2">
              <BsGraphUpArrow size={16} color="#F2953C" />{" "}
              <p className="mb-0">{rowData.TotalPriceWithProfit}</p>{" "}
            </div>
          ) : columnName === "Mile" ? (
            <p className="mb-0">{rowData.Mile}</p>
          ) : columnName === "companyProfit" ? (
            <p className="mb-0">{rowData.CompanyProfit}</p>
          ) : columnName === "TaxFee" ? (
            <div className="flex-gap-2">
              <FiDivideCircle size={16} color="#4285F4" className="rotate-45" />{" "}
              <p className="mb-0">{rowData.TaxFee}</p>{" "}
            </div>
          ) : columnName === "Delivery Fees" ? (
            <p className="mb-0">{rowData.DeliveryFees}</p>
          ) : columnName === "paymentStatus" ? (
            (page === "store" ? rowData.PaymentStatus : rowData.DriverPaymentStatus) === "PAID" ? (
              <div
                className={`${
                  page === "driver" && rowData.IsDamaged && "grid-2"
                } `}
              >
                <div className="status status-success">
                  <p className="mb-0">{t("Paid")}</p>
                </div>
                {page === "driver" && rowData.IsDamaged && (
                  <div className="status status-warning">
                    <p className="mb-0">{t("Damaged")}</p>
                  </div>
                )}
              </div>
            ) : (
              <div className="status status-failed">
                <p className="mb-0">{t("Not Paid")}</p>
              </div>
            )
          ) : columnName === "orderStatus" ? (
            rowData.OrderStatus === "RECEIVED" ? (
              <div className="status status-success">
                <p className="mb-0">{t("RECEIVED")}</p>
              </div>
            ) : rowData.OrderStatus === "PENDING" ? (
              <div className="status status-warning">
                <p className="mb-0">{t("PENDING")}</p>
              </div>
            ) : (
              <div className="status status-failed">
                <p className="mb-0">{t("NOT_RECEIVED")}</p>
              </div>
            )
          ) : (
            <p className="mb-0">
              {rowData.columnNam ? rowData.columnName : "--"}
            </p>
          )}
        </td>
      ))}
      <td className="text-end">
        <ActionRow
          handleClickRow={handleClickRow}
          data={rowData}
          // page={page === "driver" ? "driver-order" : ""}
        />
      </td>
    </tr>
  );
};

const Orders = () => {
  const { t } = useTranslation();
  const lang = sessionStorage.getItem("lang") || "en";
  const [showOffcanvas, setShowOffcanvas] = useState(true);
  const location = useLocation();
  const { state } = location;
  const [currentPage, setCurrentPage] = useState(1);
  const [recordCount, setRecordCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [loadingSubmit, setLoadingSubmit] = useState(false);

  const isLoggedIn = SessionUtil.isLoggedIn();
  const top =
    state.type === "store"
      ? lang === "en" || state.data.StoreNameAr === null
        ? state.data.StoreNameEn
        : state.data.StoreNameAr
      : lang === "en" || state.data.DriverNameAr === null
      ? state.data.DriverNameEn
      : state.data.DriverNameAr;
  const navigate = useNavigate();
  const [modalShow, setModalShow] = useState(false);
  const [rowData, setRowData] = useState({});
  const [validated, setValidated] = useState(false);
  const [price, setPrice] = useState("");
  const [isPriceError, setIsPriceError] = useState(null);
  const [isPaid, setIsPaid] = useState(false);
  const [isDamaged, setIsDamaged] = useState(false);
  const columnNames = [
    "orderNo",
    "Image",
    "Total",
    "TotalWithProfit",
    "TaxFee",
    "paymentStatus",
  ];
  const columnNamesDrivers = [
    "orderNo",
    "Image",
    "companyProfit",
    "Mile",
    "Delivery Fees",
    "notes",
    "paymentStatus",
    "orderStatus",
  ];
  const [sortedData, setSortedData] = useState([]);
  const [timeLine, setTimeLine] = useState({});
  const [msgError, setMsgError] = useState("");
  const [alertMsg, setAlertMsg] = useState(null);
  const handleFilter = (status) => {
    document.body.classList.remove("bg-offcanvas");
    setShowOffcanvas(true);
    getApi(status);
  };
  const handleClickRow = (type, data) => {
    if (type === "item") {
      navigate(`/order-items/${state.type}/${data.OrderId}`, {
        state: {
          type: state.type,
          id: data.OrderId,
          data: state.data,
          orderData: data,
        },
      });
    } else if (type === "paid") {
      setModalShow(true);
      setIsPaid(false);
      setMsgError("");
      setIsDamaged(false);
      setValidated(false);
      setIsPriceError(false);
      setRowData(data);
    }
  };
  // getApi
  const getApi = useCallback(
    async (filter) => {
      let params;
      params = {
        PageNumber: currentPage,
        PageSize: 10,
        OrderBy: "Id Desc",
        OrdersView:
          state.type === "store"
            ? { PaymentStatus: filter, StoreId: state.id, 'StatusCode' : ['RECEIVED', 'NOT_RECEIVED'] }
            : { DriverPaymentStatus: filter, DriverId: state.id, 'StatusCode' : ['RECEIVED', 'NOT_RECEIVED']},
      };

      const res = await ApiUtil.postApi(
        state.type === "store"
          ? ApiPath.GET_ALL_ORDERS
          : ApiPath.GET_ALL_DRIVER_ORDERS,
        params,
        "POST"
      );
      if (res.IsSuccessfull) {
        const totalPage = Math.ceil(res.Result.RecordCount / 10);
        setTimeLine(res.Result);
        setSortedData(res.Result.Orders);
        setRecordCount(totalPage);
        setLoading(false);
      } else {
        // getApi();
      }
    },
    [currentPage, state]
  );

  // useEffect
  useEffect(() => {
    if (isLoggedIn) {
      getApi();
    }
  }, [isLoggedIn, getApi]);

  // handlePageNumber
  const handlePageNumber = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const handleChangePrice = (e) => {
    const price = e.target.value;
    setPrice(price);
    validatedPrice(price);
  };
  const validatedPrice = (price) => {
    if (price) {
      setValidated(false);
      if (state.type === "store") {
        if (Number(price) === Number(rowData.TotalPrice)) {
          setIsPriceError(false);
          setValidated(true);
        } else {
          setMsgError(t("The price must be equal to the total order"));
          setIsPriceError(true);
        }
      } else if (!isDamaged) {
        if (Number(price) === Number(rowData.DeliveryFees)) {
          setIsPriceError(false);
          setValidated(true);
        } else {
          setMsgError(t("The price must be equal to the delivery fees"));
          setIsPriceError(true);
        }
      } else {
        if (Number(price) <= Number(rowData.DeliveryFees)) {
          setPrice(price !== "" ? Number(price) : 0);
          setIsPriceError(false);
          setValidated(true);
        } else {
          setMsgError(
            t("The price must be less than or equal to the delivery fees")
          );
          setIsPriceError(true);
        }
      }
    } else {
      setMsgError("");
    }
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true);

    if (!isDamaged) {
      if (price && !isPriceError && isPaid) {
        paymentOrdser();
      } else {
        validatedPrice(price);
      }
    } else {
      paymentOrdser();
    }
  };

  const paymentOrdser = async () => {
    setLoadingSubmit(true)
    let params = {
      Id: state.id,
      EntityName: state.type === "driver" ? "driver" : "store", //driver , store
      OrderId: rowData.OrderId,
      TotalPrice: rowData.TotalPrice,
      TotalAmountPaid: Number(price),
      IsDamaged: isDamaged,
    };
    const res = await ApiUtil.postApi(ApiPath.PAYMENT_ORDER, params, "POST");
    if (res.IsSuccessfull) {
      setLoadingSubmit(false)
      getApi();
      setCurrentPage((prev) => prev);
      setAlertMsg(true);
      setTimeout(() => {
        setAlertMsg(null);
      }, 5000);

      onHide();
    } else {
      setAlertMsg(false);
      onHide();
    }
  };
  const onHide = () => {
    setModalShow(false);
    setPrice("");
    setValidated(false);
    setMsgError("");
    setLoadingSubmit(false)
  };

  return (
    <>
      <Row className="g-0">
        {!loading ? (
          <>
            <Col lg={8} className="position-relative">
              <div className=" mt-4 d-flex justify-content-between gap-2">
                <div className="flex-gap-2">
                  {/* <Nav.Link
                    href={`${
                      state.type === "store" ? "/stores-list" : "/driver-list"
                    }`}
                  >
                    {lang === "ar" ? (
                      <IoMdArrowRoundForward size={20} />
                    ) : (
                      <IoMdArrowRoundBack size={20} />
                    )}
                  </Nav.Link> */}
                  <p className="title mb-0">
                    {state.type === "store"
                      ? t("Store Orders")
                      : t("Driver Delivered Orders")}{" "}
                    ({top}){" "}
                  </p>
                </div>
                <Filter
                  showOffcanvas={showOffcanvas}
                  setShowOffcanvas={setShowOffcanvas}
                  handleClick={handleFilter}
                />
              </div>

              {alertMsg !== null &&
                (alertMsg ? (
                  isPaid ? (
                    <Alert variant={"success"} className="mt-3">
                      {t("Payment has been made successfully")}.
                    </Alert>
                  ) : (
                    isDamaged && (
                      <Alert variant={"warning"} className="mt-3">
                        {t("The order is damaged")}
                      </Alert>
                    )
                  )
                ) : (
                  <Alert variant={"danger"} className="mt-3">
                    {t("There is an error in the process")}.
                  </Alert>
                ))}

              {msgError && !modalShow && (
                <Alert variant={"danger"} className="mt-3">
                  {t(msgError)}.
                </Alert>
              )}
              <TableComp
                data={sortedData}
                columnNames={
                  state.type === "store" ? columnNames : columnNamesDrivers
                }
                setSortedData={setSortedData}
              >
                {sortedData.map((rowData, index) => (
                  <CustomRow
                    key={index}
                    rowData={rowData}
                    columnNames={
                      state.type === "store" ? columnNames : columnNamesDrivers
                    }
                    handleClickRow={handleClickRow}
                    page={state.type}
                  />
                ))}
              </TableComp>
              <Pagination
                current={currentPage}
                total={recordCount}
                onPageChange={(pageNumber) => handlePageNumber(pageNumber)}
                extraClassName="justify-content-end"
              />
            </Col>

            <Col md={1}>
              <div className="divider-vertical mx-auto"></div>
            </Col>
            <Col lg={3} className="mt-5">
              <NavLink />
              <TimeLine data={timeLine} page="Orders" type={state.type} />
            </Col>
          </>
        ) : (
          <Col lg={12} className="loading-style">
            <ReactLoading
              type={"bars"}
              color={"#c8c8c8"}
              height={"50px"}
              width={"50px"}
            />
          </Col>
        )}
      </Row>
      <OrderModal show={modalShow} onHide={onHide} data={rowData} page="Orders">
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <div className="font-16 fw-bold">
            {t("Order Number")} : #{rowData.OrderId}
          </div>
          <Form.Group className="my-3" controlId="formGroupPrice">
            <Form.Label className="font-SemiBold">{t("Price")}</Form.Label>
            <Form.Control
              type="text"
              placeholder={t("Enter") + " " + t("Price")}
              value={price}
              inputMode="numeric"
              onKeyPress={(e) => {
                // Allow numbers, a single decimal point, and backspace
                if (!/[0-9.]/.test(e.key) && e.key !== "Backspace") {
                  e.preventDefault();
                }
                // Prevent multiple decimal points
                if (e.key === "." && price.includes(".")) {
                  e.preventDefault();
                }
              }}
              pattern="^\d*\.?\d*$"
              onChange={(e) => handleChangePrice(e)}
              isInvalid={isPriceError}
              required={!isDamaged}
            />

            <Form.Control.Feedback type="invalid">
              {msgError === ""
                ? t("Please enter") + " " + t("Price")
                : msgError}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Check
            type={"checkbox"}
            id={`Paid`}
            label={t("Paid")}
            checked={isPaid}
            onChange={(e) => setIsPaid(e.target.checked)}
            required={!isDamaged}
          />
          {state.type === "driver" && (
            <Form.Check
              type={"checkbox"}
              id={`Damaged`}
              label={t("Damaged")}
              name="status"
              checked={isDamaged}
              onChange={(e) => setIsDamaged(e.target.checked)}
            />
          )}

          <div className="d-flex justify-content-end">
            <Button
              aria-label="Aria label"
              type="submit"
              className="btn-main"
              disabled={loadingSubmit}
            >
              <div className="flex-gap-2 justify-content-center">
                {t("Save")}
                {loadingSubmit && (
                  <ReactLoading
                    type={"spin"}
                    color={"#c8c8c8"}
                    height={"20px"}
                    width={"20px"}
                  />
                )}
              </div>
            </Button>
          </div>
        </Form>
      </OrderModal>
    </>
  );
};

export default Orders;
